import { TextContainerProps } from '@/components/text-container/types';
import { Headline } from '@/components/headline/Headline';
import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import clsx from 'clsx';
import { textAlignClass } from './const';
import { renameDomProps } from '@/utils/sanitizeDomProps';

export function TextContainer({
  headline,
  description,
  textAlign = 'left',
  subtext,
  ...rest
}: TextContainerProps) {
  // Extract the first element from the headline array.
  const headlineData = Array.isArray(headline) ? headline[0] : headline;
  const alignmentClass = textAlignClass[textAlign] || textAlignClass.left;
  const renamedProps = renameDomProps(rest);
  return (
    <div
      data-component-id="C010"
      className={clsx('bg-light-grey px-4 sm:px-20', alignmentClass)}
      {...renamedProps}
    >
      <div className="container mx-auto px-4 py-12 sm:px-0 sm:py-24">
        <div className="mx-auto flex max-w-screen-lg flex-col gap-4 rounded-xl bg-white px-4 py-10 shadow-md sm:gap-6 lg:px-20">
          {headlineData && (
            <Headline {...headlineData} className="!my-0 text-brand-700">
              {headlineData.title}
            </Headline>
          )}
          {description && (
            <div className="description mt-2 hyphens-auto break-words text-neutral-700">
              <SerializeDescription description={description} />
            </div>
          )}
          {subtext && (
            <p className="mt-5 hyphens-auto break-words text-neutral-500">
              {subtext}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
